var React = require('react');

function MobileDevelopment (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("g",{"stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0},[React.createElement("path",{"d":"M26.53 52H6.47C3.45 52 1 49.638 1 46.724V6.276C1 3.362 3.449 1 6.47 1h20.06C29.55 1 32 3.362 32 6.276v40.448C32 49.638 29.551 52 26.53 52zM1 7.892h31M1.689 43.73H31.31M11.333 4.446h8.956","key":0}),React.createElement("path",{"d":"M16.844 47.865a.69.69 0 1 1-1.378 0 .69.69 0 0 1 1.378 0z","key":1})]),React.createElement("path",{"fill":"#00E3CC","d":"M2 9h29v34H2z","key":1})]));
}

MobileDevelopment.defaultProps = {"width":"33","height":"53","viewBox":"0 0 33 53"};

module.exports = MobileDevelopment;

MobileDevelopment.default = MobileDevelopment;
